import React, { Component } from 'react';
import { Route, Switch } from 'react-router-dom';
import AdminUserManagementList from './AdminUsersManagementList';

class AdminUserManagement extends Component {

    render () {
        return (
            <Switch>
                <Route path="/admin-users-management-list" exact component={ AdminUserManagementList } />
            </Switch>
        )
    }
}

export default AdminUserManagement;


// WEBPACK FOOTER //
// ./src/components/Admin-users-management/index.js